export enum Badge {
  TheNew = 'theNew',
  SuperDeal = 'superDeal',
  Upcoming = 'upcoming',
  Hybrid = 'hybrid',
  Electric = 'electric',
  Available = 'available',
}
